<template>
  <div class="vue-magnify">
    <Row>
      <Col span="12">
        <div class="preview-box" @mousemove="move" @mouseout="out" ref="previewBox" style="width:100%">
          <div :style="imageStyle"></div>
          <div class="hover-box" ref="hoverBox"></div>
        </div>
      </Col>
      <Col span="12">
        <div v-show="!zoomVisiable" class="m-l-10" align="left">
          <Button type="primary" ghost @click="rotate">旋转图片</Button>
        </div>
        <div class="zoom-box" v-show="zoomVisiable" ref="zoomBox">
          <img :src="zoomImg" ref="bigImg" :style="'transform:rotate(' + rotation + 'deg);'">
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
  const offset = el => {
    let top = el.offsetTop;
    let left = el.offsetLeft;
    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }
    return { left: left, top: top };
  };
  export default {
    name: "vue-magnify",
    props: {
      previewImg: {
        type: String,
        default: ""
      },
      zoomImg: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        pWidth: "",
        pHeight: "",
        zoomVisiable: false,
        hoverVisiable: false,
        rotation: 0,
      };
    },
    watch:{
      previewImg:{
        immediate:true,
        handler:function() {
          this.rotation = 0
        }
      }
    },
    computed: {
      imageStyle() {
        return 'width: 100%; height: 0px; padding-bottom: 100%; background: url("' +
          this.previewImg +
          '") center center / contain no-repeat; transform:rotate(' + this.rotation + 'deg);'
      }
    },
    methods: {
      rotate() {
        this.rotation += 90
        if (this.rotation === 360)
          this.rotation = 0
      },
      out() {
        this.zoomVisiable = false;
      },
      move(ev) {
        this.init();
        const scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
        const scrollY = document.getElementsByClassName("layout-content")[0].scrollTop
        // const scrollY = document.documentElement.scrollTop || document.body.scrollTop;
        let moveX = ev.clientX + scrollX;
        let moveY = ev.clientY + scrollY;
        let offsetLeft = offset(this.oPreviewBox).left;
        let offsetTop = offset(this.oPreviewBox).top;
        let left = moveX - offsetLeft - this.houverWidth / 2;
        let top = moveY - offsetTop - this.houverHeight / 2;
        let maxWidth = this.pWidth - this.houverWidth;
        let maxHeight = this.pHeight - this.houverHeight;
        left = left < 0 ? 0 : left > maxWidth ? maxWidth : left;
        top = top < 0 ? 0 : top > maxHeight ? maxHeight : top;
        let percentX = left / maxWidth;
        let percentY = top / maxHeight;
        this.oHoverBox.style.left = left + "px";
        this.oHoverBox.style.top = top + "px";
        this.oBigImg.style.left = percentX * (this.bWidth - this.imgWidth) + "px";
        this.oBigImg.style.top =
          percentY * (this.bHeight - this.imgHeight) + "px";
        this.$emit("move", ev);
        this.zoomVisiable = true;
      },
      init() {
        this.oHoverBox = this.$refs.hoverBox;
        this.oPreviewBox = this.$refs.previewBox;
        this.oBigImg = this.$refs.bigImg;
        this.imgBox = this.$refs.zoomBox;
        this.houverWidth = this.oHoverBox.offsetWidth;
        this.houverHeight = this.oHoverBox.offsetHeight;
        this.pWidth = this.oPreviewBox.offsetWidth;
        this.pHeight = this.oPreviewBox.offsetHeight;
        this.imgWidth = this.oBigImg.naturalWidth;
        this.imgHeight = this.oBigImg.naturalHeight;
        this.bWidth = this.imgBox.offsetWidth;
        this.bHeight = this.imgBox.offsetHeight;
        // console.log("magnify", this.houverWidth, this.houverHeight, this.pWidth, this.pHeight, this.imgWidth, this.imgHeight, this.bWidth, this.bHeight)
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .vue-magnify {
    position: relative;
    .preview-box {
      position: relative;
      &:hover .hover-box {
        display: block;
      }
      .hover-box {
        position: absolute;
        display: none;
        left: 0;
        top: 0;
        width: 100px;
        height: 100px;
        border: 1px solid #545454;
        background: url("https://img-tmdetail.alicdn.com/tps/i4/T12pdtXaldXXXXXXXX-2-2.png") repeat 0 0;
        cursor: move;
        user-select: none;
      }
      img {
        height: 300px;
      }
    }
    .zoom-box {
      overflow: hidden;
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom:100%;
      z-index: 5;
      border: 1px solid #bbb;
      img {
        position: absolute;
        top: 0;
        left: 0;
        max-height: initial;
        max-width: initial;
      }
    }
  }
</style>